import { WarningIcon } from '@icons';

type WarningsListBannerProps = {
  messages: string[];
};

export const WarningsListBanner = ({ messages }: WarningsListBannerProps) => {
  if (!messages.length) return null;

  return (
    <div className="w-full flex gap-2 px-2 items-stretch border-l-8 border-warning-40 bg-warning-80 overflow-hidden rounded-lg">
      <div className="flex flex-col gap-1 py-2 pr-2">
        {messages.map((warning) => (
          <div key={warning} className="flex gap-2 text-warning-40 items-center">
            <div className="shrink-0">
              <WarningIcon />
            </div>
            <span className="text-m-r text-warning-5">{warning}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
